import React from 'lib/react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, EVSkeleton } from 'lib/components';

const skeletonLoaderStyles = makeStyles(() => ({
  root: ({ width, height, borderRadius }) => ({
    width,
    height,
    borderRadius,
  }),
}));
function SkeletonLoader({
  width, height, borderRadius, className, ...rest
}) {
  const classes = skeletonLoaderStyles({ width, height, borderRadius });
  return (<EVSkeleton className={clsx(classes.root, className)} animation="wave" variant="rect" {...rest} />);
}

SkeletonLoader.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
};

SkeletonLoader.defaultProps = {
  width: '100%',
  height: '24px',
  borderRadius: '6px',
  className: null,
};

export default SkeletonLoader;
